var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"error-card-wrapper"},[_c('div',{staticClass:"header"},[_c('v-icon',{staticClass:"icon",attrs:{"medium":""}},[_vm._v(" "+_vm._s(_setup.icon)+" ")]),_vm._v(" "+_vm._s(_setup.header)+" ")],1),_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_setup.content)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }